var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "sm:col-span-1" }, [
    _c("dd", { staticClass: "mt-1 text-sm leading-5 text-gray-900" }, [
      _c(
        "div",
        { staticClass: "flex items-center overflow-hidden cursor-pointer" },
        [
          _vm.items.length
            ? [
                _vm._l(_vm.items.slice(0, 4), function (item, i) {
                  return _c(
                    "div",
                    { key: item.id, class: `${_vm.getZIndex(i)}` },
                    [
                      item.avatar
                        ? [
                            _c("s3-image", {
                              class: `relative inline-block h-6 w-6 rounded-full text-white shadow-solid object-cover`,
                              attrs: { s3FileKey: item.avatar, alt: "" },
                            }),
                          ]
                        : [
                            _c(
                              "span",
                              {
                                class: `relative inline-flex items-center justify-center inline-block h-6 w-6 rounded-full text-white shadow-solid text-xs font-bold leading-none`,
                                style: `background-color: ${_vm.initialColor()}`,
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    item.given_name[0] + item.family_name[0]
                                  )
                                ),
                              ]
                            ),
                          ],
                    ],
                    2
                  )
                }),
                _vm.items.length > 4
                  ? _c("span", { staticClass: "ml-2" }, [
                      _vm._v("+" + _vm._s(_vm.items.length - 4)),
                    ])
                  : _vm._e(),
              ]
            : [_vm._v("-")],
        ],
        2
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }